<template>
    <section id="chat-modal" class="modal">
        <div id="chat-topbar" class="bck-second">
            <button class="arrow" v-show="(isMobile && isChatCardOpen)" @click="closeChat()"><i
                    class="left"></i></button>
            <div v-show="isChatCardOpen" class="w-100 text-a-c text-third m-r-5 p-r-5">
                <p>Rozmowa z:
                    <small id="chat-user-name"></small>
                </p>
            </div>
        </div>
        <div id="chat-sidebar" class="bck-second-d text-second-l" v-show="(isMobile && !isChatCardOpen) || !isMobile">
            <small class="w-100 text-a-c" style="padding: 6px 0;">Wybierz osobę, aby przejść do rozmowy.</small>
            <input v-model="filterText" class="filter-friends"/>
            <hr class="m-b-0">
            <div class="m-t-0 w-100">
                <div @click="selectChat(oneChat.id)" class="card-body display-flex one-chat"
                     v-bind:class="{ 'chat-actived': oneChat.isActive, 'chat-not-read': oneChat.noReadCount > 0 }"
                     v-for="oneChat in chatFilteredCounteredList" :key="oneChat.id">
                    <div class="center-flex-a" style="height: auto;">
                        <img class="circle-profile" :src="oneChat.profile_img" :alt="oneChat.firstname">
                    </div>
                    <div class="p-l-2" style="width: calc(100% - 45px); align-self: center">
                        <h5 class="text-second w-100">{{oneChat.firstname}} <b>{{oneChat.lastname}}</b></h5>
                    </div>
                    <span class="chat-count" v-if="oneChat.noReadCount > 0">{{oneChat.noReadCount}}</span>
                </div>
            </div>
        </div>
        <div id="chat-content" v-show="(isMobile && isChatCardOpen) || !isMobile">
            <div v-show="!notSelected && !isChatLoad" id="chat-message">

            </div>
            <div v-show="!notSelected && !isChatLoad" id="chat-control">
                <textarea v-model="message" @keyup.enter="sendMessage" name="" id=""
                          style="height: 100px; width: 100%"></textarea>
                <div id="chat-control-actions">
                    <button><i class="far fa-image"></i></button>
                    <button id="chat-control-action-send" @click="sendMessage">Wyślij</button>
                </div>
            </div>
            <div v-if="notSelected && !isChatLoad && !isChatCardOpen">
                <h3 class="center-flex-a text-third-d" style="min-height: 70vh; margin: 0 100px; text-align: center">
                    Wybierz osobę z którą chcesz przeprowadzić konwersację z menu po lewej</h3>
            </div>
            <div v-if="isChatLoad">
                <h3 class="center-flex-a text-third-d" style="margin: 100px 100px 0; text-align: center"> Poczekaj
                    chwilkę proszę, pobieram Twoje wiadomości</h3>
                <div class="searchLoader">
                    <div class="span">
                        <div class="help"></div>
                    </div>
                </div>
            </div>
        </div>
        <div id="nofriendsmodal" class="modal">
            <div class="modal-header">
                Brak znajomych
            </div>
            <div class="modal-body" style="max-width: 600px">
                <p class="p-3">Niestety nie posiadasz jeszcze znajomych. Możesz wyszukać i dodać nowych przechodząc do zakładki "znajomi"</p>
                <p class="p-x-3 p-t-0" @click.prevent="showFriends()"><router-link to="/friends">Przejdź do zakładki znajomi</router-link></p>
            </div>
        </div>
        <div class="nofriendsmodal-shadow"></div>
    </section>
</template>

<script>

    export default {
        name: "ChatModal",
        data: function () {
            return {
                message: '',
                filterText: '',
                isMobile: false,
                isChatCardOpen: false,
                notSelected: true
            }
        },
        methods: {
            closeChat(){
                this.$store.dispatch('closeChat');
                this.isChatCardOpen = false;
                Chat.currentChatId = null;
            },
            selectChat(chatId) {
                this.isChatCardOpen = true;
                this.notSelected = false;
                this.$store.dispatch('openChat', chatId);
            },
            sendMessage() {
                this.message = this.message.trim();
                try {
                    let valid = new Validator({
                        "wiadomość": this.message,
                    });
                    valid.get("wiadomość").length(2);
                } catch (e) {
                    return
                }
                Chat.addNewMessage(this.message);
                this.message = '';
            },
            showFriends() {
                this.hideModal('#chat-modal');
                this.hideModal('#nofriendsmodal');
                $('.nofriendsmodal-shadow').css('display', '');
            }
        },
        mounted: function () {
            this.isMobile = ($(window).width() < 650);
            $(window).resize(() => {
                this.isMobile = ($(window).width() < 650);
            });
            $(document).on('click', '#nofriendsmodal .modal-close', this.showFriends);
        },
        destroyed(){
            $(window).off('resize');
        },
        computed: {
            chatFilteredCounteredList: function () {
                return this.chatCounteredList.filter((value) => {
                    if (this.filterText.length <= 0) return true;
                    else {
                        return (value.firstname.includes(this.filterText) || value.lastname.includes(this.filterText));
                    }
                });
            },
            isChatLoad: function () {
                return this.$store.state.chat.isChatLoad;
            },
            chatCounteredList: function () {
                return this.$store.state.chat.counteredList;
            }
        }
    }
</script>

<style lang="scss">
    /*#chat-modal {*/
    /*visibility: visible;*/
    /*opacity: 1;*/
    /*}*/

    .nofriendsmodal-shadow {
        display: none;
        position: absolute;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.75);
        z-index: 1;
    }

    #nofriendsmodal .modal-close {
        position: absolute;
        width: 20px;
        height: 20px;
        overflow: hidden;
        cursor: pointer;
        top: 8px;
        right: 10px;
        padding: 0;
        background: transparent;
    }

    #nofriendsmodal .modal-close:hover {
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
    }

    #nofriendsmodal .modal-close::before, #nofriendsmodal .modal-close::after {
        background: #cbcbcb;
        width: 100%;
        left: 0;
    }

</style>